export default __webpack_public_path__ + "static/media/faq-tablet.9604977c.jpg";